import React from "react";
import Pageslayout from "../../Layouts/Pageslayout";
import PageIntro from "../../components/PageIntro";
const Index = ({ title, description }) => {
  return (
    <Pageslayout
      pageintro={true}
      title="Terms and Privacy policy"
      description="Please stay tuned for further updates."
    ></Pageslayout>
  );
};

export default Index;
